export const ADD_CONNECTOR = "ADD_CONNECTOR"
export const REMOVE_CONNECTOR = "REMOVE_CONNECTOR"
export const SET_CONNECTORS_LIST = "SET_CONNECTORS_LIST"
export const UPDATE_CONNECTORS_LIST = "UPDATE_CONNECTORS_LIST"

export interface IConnectorModel {
    id: string
    name: string
    color: string
    iconSrc: string
    description: string
    shortDescription: string
}

export interface IAddConnector {
    type: typeof ADD_CONNECTOR
    connector: IConnectorModel
}

export interface IRemoveConnector {
    type: typeof REMOVE_CONNECTOR
    id: string
}

export interface ISetConnectorsList {
    type: typeof SET_CONNECTORS_LIST
    list: IConnectorModel[]
}

export type IConnectorsActionTypes = IAddConnector | IRemoveConnector | ISetConnectorsList
